import { ChangeEvent, FC, FocusEventHandler, memo } from 'react'
import { CompanyType, allCompanyTypes } from '@leadgen/models/client'
import Box from '@mui/material/Box'
import CompanyTypeTile from './CompanyTypeTile'

const CompanyTypeGrid: FC<{
  companyType?: CompanyType | null
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
}> = ({ companyType: selectedCompanyType, onChange, onBlur }) => {
  return (
    <Box
      component={'ul'}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 2,
        padding: 2,
        margin: 0,
      }}
    >
      {allCompanyTypes.map(companyType => {
        return (
          <CompanyTypeTile
            key={companyType}
            companyType={companyType}
            onChange={onChange}
            onBlur={onBlur}
            selected={companyType === selectedCompanyType}
          />
        )
      })}
    </Box>
  )
}

export default memo(CompanyTypeGrid)
